<template>
	<div class="rit_menlian">
		<div class="group">

			<ul>
				<li>
					<a href="https://www.facebook.com/Loctokservice/" target="_blank">
						<img src="../../static/img13.jpg" />
					</a>
				</li>
				<li style="transform: translateX(-3px);" class="rit_two" >
					<span class="common_pc_show">
						<a href="https://web.whatsapp.com/send?phone=+1(720)722-0502" target="_blank">
							<img src="../../static/img14.jpg" />
						</a>
					</span>
					<span class="common_phone_show">
						<a href="whatsapp://send?phone=+1(720)722-0502" target="_blank">
							<img src="../../static/img14.jpg" />
						</a>
					</span>
				</li>
				<li>
					<a href="https://twitter.com/LoctokS" target="_blank">
						<img src="../../static/img15.jpg" />
					</a>
				</li>
				<li>
					<a href="https://www.instagram.com/loctok_test/" target="_blank" class="rit_therr" style="transform: translateX(6px);">
						<img src="../../static/p42.png" style="width: 35px;" />
					</a>
				</li>
				<li>
					<a href="mailto:loctok013@gmail.com">
						<img src="../../static/img20.jpg" />
					</a>
				</li>
				<li>
					<a href="#"  style="transform: translateX(2px);">
						<img src="../../static/img21.jpg" />
					</a>
				</li>
			</ul>

		</div>
	</div>
</template>

<script>
	export default {
		name: 'RitMenlian',
		props: {
			msg: String
		}
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	.rit_menlian {
		position: fixed;
		right: 55px;
		top: 50%;
		background: #fff;
		padding: 15px 0;
		width: 70px;
		z-index: 99;
		transform: translate(0, -50%);
		border-radius: 10px;
		box-shadow: 0px 1px 2px rgba(181, 181, 181, 0.5);
	}

	.rit_menlian ul li a {
		display: block;
		padding: 7.5px 12px;
	}

	@media screen and (max-width:1200px) {
		.rit_menlian {
			width: 40px;
			right: 5px;
		}
	}
</style>
